<template>
  <div class="peopleindex">
    <div class="toolAndFilter">
      <div class="tool">
        <div style="display: inline-block;margin-right: 30px;">
          <el-button v-if="role.includes('downs')" :disabled="multipleSelection.length == 0" style="border-radius: 4px"
            size="medium" type="good" icon="el-icon-download" @click="downAll">批量下载
          </el-button>
          <!-- v-if="!adminFlag" :disabled="peopleTableData.length>0" -->
          <!--  -->
          <el-button v-if="role.includes('add')" :disabled="peopleTableData.length > 0" style="border-radius: 4px"
            size="medium" type="warning" icon="el-icon-edit-outline" @click="xuzhiDialog = true">在线填写
          </el-button>
          <el-button v-if="role.includes('up')" :disabled="peopleTableData.length > 0" style="border-radius: 4px"
            size="medium" type="primary" icon="el-icon-upload2" @click="shangchuanHandler">上传文档
          </el-button>
          <el-button v-if="role.includes('up')" style="border-radius: 4px" size="medium" type="text"
            @click="xiaZaiMoBan">下载模板
          </el-button>
        </div>
      </div>
      <div class="filter">
        <div style="display: inline-block;max-width: 400px;flex-basis: 400px">
          <el-input v-model="query.fileName" size="medium" placeholder="输入文件名称" clearable @clear="sreachTableData"
            @keyup.native.13="sreachTableData">
            <el-button slot="append" size="medium" type="good" icon="el-icon-search" @click="sreachTableData">查询
            </el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="body">
      <el-table ref="multipleTable" :data="peopleTableData" height="100%" style="width: 100%" row-key="id"
        @selection-change="handleSelectionChange">
        <el-table-column v-if="role.includes('downs')" :reserve-selection="true" type="selection" width="55">
        </el-table-column>
        <el-table-column v-else type="index" label="#" width="50">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="fileName" label="文件名称" min-width="120">
          <template slot-scope="scope">
            <div class="columnStyle">
              <img :src="require(`@/assets/image/fileicon/${scope.row.fileType || 'doc'}.png`)">
              <span>{{ scope.row.fileName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: flex-end">
              <el-button v-if="role.includes('edit') && scope.row.proposal" size="mini" plain type="warning"
                icon="el-icon-edit-outline" @click="tianjiaHandler(scope.row.id, 'edit')">修改
              </el-button>
              <el-button v-if="role.includes('see') && ['pdf', 'jpeg', 'jpg', 'png'].includes(scope.row.fileType)"
                size="mini" plain type="success" icon="el-icon-view"
                @click="previewFile(scope.row.fileUrl, scope.row.fileType)">查看
              </el-button>
              <el-button v-if="role.includes('see') && scope.row.proposal" size="mini" plain type="success"
                icon="el-icon-view" @click="tianjiaHandler(scope.row.id, 'view')">查看
              </el-button>
              <el-button v-if="role.includes('down')" size="mini" plain type="primary" icon="el-icon-download"
                @click="downloading(scope.row)">下载
              </el-button>
              <el-button v-if="role.includes('del')" size="mini" plain type="danger" icon="el-icon-delete"
                @click="handlerRemoveClick(scope.row)">
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tablePagination">
      <el-pagination background :current-page="query.pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="query.pageSize"
        layout="total, prev, pager, next, jumper" :total="query.totalRecord" @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <el-dialog class="addDialog" :title="formDialog.edit ? '编辑' : '上传文件'" :visible.sync="formDialog.formVisible"
      @close="cancelForm('form')">
      <el-form ref="form" :model="form" :rules="rules" label-width="0px" size="small">
        <div class="info">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="files">
                <el-upload ref="upload" class="upload-demo" action="none" :limit="1" drag :http-request="uploadServer"
                  :before-upload="beforeAvatarUpload" :on-remove="fileRemove" :file-list="files"> <i
                    class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div slot="tip" class="el-upload__tip">只能上传doc(x)、jpeg、png、jpg、pdf文件，且不超过30MB</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取消</el-button>
        <!-- <el-button
          type="good"
          @click="submitForm('form')"
        >确定</el-button> -->
      </div>
    </el-dialog>
    <ElImageViewer v-if="viewShow" :on-close="closeViewer" :url-list="srcList"></ElImageViewer>
    <el-dialog class="wordDialog" :show-close="false" fullscreen :visible.sync="word.show">
      <div class="contentBody">
        <div class="title">
          <!-- <el-button
            style="border-radius: 4px"
            size="medium"
            type="good"
            icon="el-icon-arrow-left"
            @click="word.show=false"
          >返回
          </el-button> -->
        </div>
        <div class="content">
          <Word :id="word.id" ref="word" :congress-id="query.congressId" :type="word.type" :show="word.show"
            @submit="submitResult"></Word>
        </div>
        <div class="footer">
          <el-button style="border-radius: 4px" size="medium" :type="word.type === 'view' ? 'good' : ''"
            @click="word.show = false">取消
          </el-button>
          <el-button v-show="word.type != 'view'" style="border-radius: 4px" size="medium" type="good" :loading="loading"
            @click="submit">确定
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="xuzhiDialog" style="margin-top:-5vh" @close="closeXuzhi" width="990px">
      <iframe style="width: 100%; height: 700px;" :src="`${url}/pdf/web/viewer.html?file=${url}/static/xz.pdf`"
        frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import {
  page,
  creates,
  update,
  deleteById,
  uploadFile,
  updateFile,
  // deleteFile,
  downloadFile,
  batchDownloadFile
} from '@/api/suggestion/index'

import {
  downloadFile as downloadFileUrl
} from '@/api/file/index'
import {
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Row, Message,
  Col,
  MessageBox,
  Upload,
  Image
} from 'element-ui';
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { includeFileType } from "@/utils/index";
import downloadjs from 'downloadjs';
import Word from './Word'
import storage from 'store'
export default {
  name: "FileTableOne",
  components: {
    // UploadImg,
    Word,
    [Button.name]: Button,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    [Image.name]: Image,
    ElImageViewer
  },
  data () {
    let id = this.$route.params.id;
    let that = this;
    const validateFilesUrl = (rule, value, callback) => {
      if (that.fileList.length < 1) {
        callback(new Error("请上传文件"))
      } else {
        callback()
      }
    };
    let url = process.env.BASE_URL;
    return {
      url: url,
      xuzhiDialog: false,
      multipleSelection: [],
      word: {
        type: 'add',
        show: false,
        id: ''
      },
      loading: false,
      viewShow: false,
      srcList: [],
      role: {},
      user: {},
      peopleTableData: [],
      query: {
        pageNum: 1,
        pageSize: 2,
        totalRecord: 0,
        fileName: "",
        congressId: id,
        state: '1'
      },
      form: {
        'id': '',
        "files": ""
      },
      rules: {
        files: [
          {
            required: true,
            validator: validateFilesUrl,
            trigger: 'blur'
          },
        ],
      },
      fileList: [],
      files: [],
      formDialog: {
        loading: false,
        edit: false,
        peopleOption: [],
        formVisible: false
      },
    }
  },
  created () {
    let role = storage.get('role');
    this.user = storage.get('User-Info');
    this.role = role['syyjm'];
    this.getList();
  },
  methods: {
    closeXuzhi () {
      this.tianjiaHandler('', 'add');
    },
    xiaZaiMoBan () {
      let a = document.createElement("a"); //创建一个<a></a>标签
      a.href = `${this.url}/static/常德市人大常委会会议审议意见卡.doc`; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "常德市人大常委会会议审议意见卡.doc"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    downAll () {
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id)
      }
      ids = ids.join(',');
      batchDownloadFile({ ids }).then(res => {
        downloadjs(res, `${storage.get('title')}.zip`, 'application/zip')
        Message({
          message: "下载成功",
          type: "success",
        });
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;//this.unique(val);
    },
    //数组去重
    unique (arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    submitResult (e) {
      if (e) {
        this.word.show = false;
        this.sreachTableData();
      }
      this.loading = false;
    },
    submit () {
      this.loading = true;
      this.$refs['word'].submit();
    },
    //下载文件方法
    downloading (data) {
      if (data.proposal) {
        downloadFile({
          id: data.id
        }).then(res => {
          downloadjs(res, data.fileName)
        })
      } else {
        downloadFileUrl({
          fullPath: data.fileUrl,
          originalName: data.fileName
        }).then(res => {
          downloadjs(res, data.fileName)
        })
      }
    },
    shangchuanHandler () {
      this.formDialog.formVisible = true;
      this.form.id = '';
      this.formDialog.edit = false;
    },
    sizeTostr (size) {
      let data = "";
      if (size < 0.1 * 1024) { //如果小于0.1KB转化成B
        data = size.toFixed(2) + "B";
      } else if (size < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
        data = (size / 1024).toFixed(2) + "KB";
      } else if (size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
        data = (size / (1024 * 1024)).toFixed(2) + "MB";
      } else { //其他转化成GB
        data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizestr = data + "";
      let len = sizestr.indexOf(".");
      let dec = sizestr.substr(len + 1, 2);
      if (dec == "00") {//当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      }
      return sizestr;
    },
    async uploadServer (param) {
      let that = this;
      let fd = new FormData();
      fd.append("mpFile", param.file);
      that.isProgress = true; //显示上传进度
      that.progressNum = 0; //重置进度值
      const config = {
        onUploadProgress: progressEvent => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          let progressNum = Number(((progressEvent.loaded / progressEvent.total) * 100).toFixed(
            2));
          param.onProgress({ percent: progressNum })
        }
      };
      let res = await uploadFile(fd, config)
      if (res.status === 1) {
        Message({
          message: "上传成功",
          type: "success",
        });
        res.data.congressId = that.query.congressId;
        updateFile(res.data).then(() => {
          that.closeForm();
          that.sreachTableData();
        })
      } else {
        Message({
          message: "上传失败",
          type: "error",
        });
        that.isProgress = false;
      }
    },
    //上传对文件大小判断与限制
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        Message.warning("上传文件大小不能超过 30MB!");
        return false;
      }
      let fileName = file.name; //文件名称
      let length = fileName.substr(0, fileName.lastIndexOf(".")).length;
      if (length > 100) {
        Message.warning("文件名称过长，总长度不能超过100!");
        return false;
      }
      let f = includeFileType(fileName, ['doc', 'docx', 'jpeg', 'png', 'jpg', 'pdf'])
      if (!f) {
        Message.warning("不能上传此文件格式");
        return false;
      }
    },
    handlerRemoveClick (data) {
      let that = this;
      MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteById(
          data.id
        ).then(res => {
          if (res.status == 1) {
            Message.success('删除成功');
            that.sreachTableData();
          }
        })
      })
    },
    fileRemove (file) {
      const i = this.fileList.findIndex(x => x.uid === file.raw.uid);
      this.fileList.splice(i, 1);
      // deleteFile({ fileUrl: f[0].fileUrl }).then(() => {
      //
      // })
    },
    closeForm () {
      this.fileList = [];
      this.$refs.upload.clearFiles();
      this.formDialog.formVisible = false;
    },
    submitForm (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.formDialog.edit) {
            update(that.form).then(res => {
              if (res.status == 1) {
                Message.success('修改成功');
                that.getList();
                that.formDialog.formVisible = false;
              }
            })
          } else {
            creates(that.fileList).then(res => {
              if (res.status == 1) {
                Message.success('添加成功');
                that.formDialog.formVisible = false;
                that.sreachTableData();
              }
            })
          }
        }
      });
    },
    areaCodesChangeHandler (f, val) {
      if (val) {
        this.form[f] = val[val.length - 1];
      }
    },
    cancelForm (formName) {
      this.fileList = [];
      this.$refs.upload.clearFiles();
      this.formDialog.peopleOption = [];
      this.$refs[formName].resetFields();
    },
    /**
     * 从业人员添加
     */
    tianjiaHandler (id, type) {
      this.word.show = true;
      this.word.type = type;
      this.word.id = id;
    },
    XiuGaiHandler () {
      let that = this;
      that.formDialog.formVisible = true;
      that.formDialog.edit = true;
    },
    getList () {
      let that = this;
      if (!this.role.includes('downs')) {
        that.query.createUserId = that.user.userId
      }
      let f = JSON.parse(JSON.stringify(that.query));
      page(f).then(res => {
        if (res.status == 1) {
          let d = res.rows;
          for (let i in d) {
            d[i].type = ''
          }
          that.peopleTableData = res.rows;
          that.query.totalRecord = res.total;
          // this.$refs.multipleTable.toggleRowSelection(this.multipleSelection);
        }
      })
    },
    sreachTableData () {
      this.query.pageNum = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.query.pageNum = val;
      this.getList();
    },
    handleSizeChange (val) {
      this.query.pageSize = val;
      this.handleCurrentChange(1);
    },
    closeViewer () { this.viewShow = false; this.srcList = []; },
    //预览文件
    previewFile (url, type) {
      if (['jpeg', 'jpg', 'png'].includes(type)) {
        this.viewShow = true;
        this.srcList[0] = url
      } else if (type === 'pdf') {
        window.open(`${process.env.BASE_URL}/pdf/web/viewer.html?file=${encodeURIComponent(url)}`);
      } else {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`)
      }
    },
  }
}
</script>

<style scoped>
div {
  word-break: break-all;
}

.peopleindex {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.peopleindex .body {
  height: 0;
  flex-grow: 1;
}

.peoples {
  display: flex;
  flex-wrap: wrap;
}

.peoples .people {
  width: 390px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(16, 16, 16, 100);
  font-family: Roboto;
  border: 1px solid rgba(230, 230, 230, 100);
  padding: 16px;
  display: flex;
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-regular;
  line-height: 1.77em;
  margin: 0 16px 16px 0;
  flex-shrink: 0;
}

.peoples .people .headImg {
  width: 120px;
  height: 170px;
  position: relative;
  flex-shrink: 0;
  margin-right: 20px;
}

.peoples .people .headImg .tip {
  position: absolute;
  width: 100%;
  height: 24px;
  line-height: 24px;
  background-color: rgba(46, 136, 242, 100);
  text-align: center;
  bottom: 0;
  left: 0;
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.people .tit {
  color: rgba(16, 16, 16, 100);
  font-size: 18px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.toolAndFilter {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}

.toolAndFilter .tool {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.toolAndFilter .filter {
  justify-content: flex-end;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.tablePagination {
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-button {
  border-radius: 4px;
}

.el-form>>>.el-input__inner {
  border-radius: 4px;
}

.addDialog.el-dialog__wrapper>>>.el-dialog__body {
  display: block;
  overflow: auto;
  flex-grow: initial;
  flex-shrink: initial;
  flex-basis: initial;
}

.el-table .el-button+.el-button {
  margin-left: 10px;
  position: relative;
}

/* .el-table .el-button + .el-button::before {
  content: '';
  display: block;
  width: 0;
  height: 14px;
  border-right: 1px solid #999;
  position: absolute;
  left: -9px;
  top: 50%;
  transform: translateY(-50%);
} */

.el-table .el-button.delect {
  color: #ff5342;
}

.el-image-viewer__wrapper>>>img {
  object-fit: contain;
}

.columnStyle {
  /* font-size: 16px; */
  padding-left: 30px;
  position: relative;
}

.columnStyle img {
  width: 18px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.contentBody {
  position: relative;
  height: 100%;
  overflow: auto;
}

.contentBody .title {
  position: absolute;
  height: 60px;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 16px;
}

.wordDialog>>>.el-dialog__header {
  padding: 0;
}

.wordDialog>>>.el-dialog__body {
  padding: 0;
  height: 100%;
}

.wordDialog .content {
  overflow: auto;
  height: 100%;
  padding: 60px 0 80px;
}

.contentBody .footer {
  position: absolute;
  height: 60px;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0px -3px 17px #c7c1c194;
}
</style>